import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const Pagination = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    
    .page {
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 8px;
        border: 1px solid ${(props) => props.theme.orangeLink};
        border-radius: 8px;
        color: ${(props) => props.theme.orangeLink};
        font-weight: bold;
        cursor: pointer;
        font: ${theme.font.body[1]};

        &.active {
            color: ${(props) => props.theme.white};
            background: ${(props) => props.theme.orange};
        }
    }
`;

export const SimplePagination = styled.div`
    display: flex;
    position: absolute;
    justify-content: flex-end;
    top: 50%;
    width: 32px;
`;

export const IconBorder = styled.div`
    position: absolute;
    right: ${({ isLeft }) => (isLeft ? '527px' : '-494px')};
    border: solid 1px ${(props) => props.theme.blackLink};
    width: 32px;
    height: 32px;
    border-radius: 50px;
    padding-top: 4.5px;
    background-color: ${(props) => props.theme.blackLink};
    
    & svg {
        margin-left: ${({ isLeft }) => (isLeft ? '3px' : '5px')};
    }
`;

export const PaginationText = styled.div`
    font: ${theme.font.body[3]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.orangeLink};
    text-decoration: underline;
`;
